<template>
  <div class="animated fadeIn">
    <Forms
      ref="frmGroup"
      :title="'CADASTRO DE PARÂMETROS DA API DE SMS CLASSE A'"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave"
    >
      <div class="form-group row">
        <div class="col-md-3">
          <NxInput
            name="usuario"
            type="text"
            label="Usuário:"
            placeholder="Digite o usuario"
            error-behavior="value"
            :value="data.usuario"
            @update:value="handleInputUpdate('usuario', $event)"
          ></NxInput>
        </div>
        <div class="col-md-3">
          <NxInput
            name="senha"
            type="password"
            label="Senha:"
            placeholder="Digite a senha"
            :value="data.senha"
            @update:value="handleInputUpdate('senha', $event)"
          ></NxInput>
        </div>
        <div class="col-md-3">
          <NxInput
            name="codigoCarteira"
            type="text"
            label="Código da carteira:"
            placeholder="Digite o código da carteira"
            :value="data.codigoCarteira"
            @update:value="handleInputUpdate('codigoCarteira', $event)"
          ></NxInput>
        </div>
        <div class="col-md-3">
          <NxInput
            name="codigoFornecedor"
            type="text"
            label="Código do forncededor:"
            placeholder="Digite o código do forncededor"
            :value="data.codigoFornecedor"
            @update:value="handleInputUpdate('codigoFornecedor', $event)"
          ></NxInput>
        </div>
      </div>
    </Forms>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import { advancedOnException } from '@/components/tools/Utils'

import ParametroClasseA from '@/shared/http/repositories/configurations/parametroClasseA'

const data = {
  id: null,
  usuario: null,
  senha: null,
  codigoCarteira: null,
  codigoFornecedor: null
}

export default {
  name: 'NewClasseAParams',
  mixins: [ActionsForm],
  data () {
    return {
      data: data
    }
  },
  methods: {
    onLoad () {
      ParametroClasseA.GetAll()
        .then(response => {
          if (response.data) {
            this.data = response.data
          }
        })
        .catch((error) => console.error(error))
    },
    onCreate () {
      loading.push()

      ParametroClasseA.Create(this.data)
        .then((response) => {
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((error) => advancedOnException(error, this.$lang))

      loading.close()
    },
    onUpdate () {
      loading.push()

      this.data.id = parseInt(this.data.id)
      ParametroClasseA.Create(this.data)
        .then((response) => {
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((error) => advancedOnException(error, this.$lang))

      loading.close()
    },
    handleInputUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        this.data[fieldName] = inputedValue
      } else {
        this.clearField(fieldName)
      }
    },
    clearField (field) {
      this.form[field] = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/classeA/NewClasseAParams.vue